import { render, staticRenderFns } from "./RefoundRequest.vue?vue&type=template&id=4efeb8d6"
import script from "./RefoundRequest.vue?vue&type=script&lang=js"
export * from "./RefoundRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports